import { render, staticRenderFns } from "./OBooleanSelect.vue?vue&type=template&id=34ef132e&scoped=true&"
import script from "./OBooleanSelect.vue?vue&type=script&lang=js&"
export * from "./OBooleanSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef132e",
  null
  
)

export default component.exports